import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { WhatsNewRelease } from 'src/app/whats-new.config';

export type WhatsNewDialogResult = 'acknowledged' | 'learn-more';

@Component({
  standalone: false,
  selector: 'app-whats-new-dialog',
  templateUrl: './whats-new-dialog.component.html',
  styleUrls: ['./whats-new-dialog.component.scss'],
})
export class WhatsNewDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<WhatsNewDialogComponent, WhatsNewDialogResult>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: WhatsNewRelease
  ) {}

  onGotIt(): void {
    this.dialogRef.close('acknowledged');
  }

  onLearnMore(): void {
    const url = this.data.learnMoreUrl;
    if (url) {
      if (/^https?:\/\//i.test(url)) {
        window.open(url, '_blank', 'noopener');
      } else {
        this.router.navigateByUrl(url);
      }
    }
    this.dialogRef.close('learn-more');
  }
}
